import type { SliceComponentProps} from "@prismicio/react";
import { asText } from "@prismicio/helpers";
import { useLocalePath } from "@commercekit/remix";
import React from "react";
import WvLink from "~/components/atoms/WvLink";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import type { BreadcrumbsSlice } from "~/lib/prismic/types.generated";
const Breadcrumbs = ({ slice }: SliceComponentProps<BreadcrumbsSlice>) => {
  const { $pt } = usePrismicLabels();
  const localePath = useLocalePath();
  const lastPath = slice.items[slice.items.length - 1];

  return (
    <div className="container">
      <div className="breadcrumbs py-3 mb-3">
        <WvLink
          to={localePath("/")}
          className="page first"
          data-icon-before=""
        >
          {$pt("breadcrumbs_label_home")}
        </WvLink>
        {slice.items &&
          slice.items.map((item, index) =>
            lastPath.text === item.text ? (
              <span key={asText(item?.text) + index}>{asText(item.text)}</span>
            ) : (
              <WvLink
                to={localePath(`/${asText(item.link)}`)}
                data-icon-before=""
                key={asText(item?.text) + index}
              >
                {asText(item.text)}
                <i data-icon-after=""></i>
              </WvLink>
            )
          )}
      </div>
    </div>
  );
};
export default Breadcrumbs;
